import { createSelector } from 'reselect'
import orderBy from 'lodash/orderBy'
import filter from 'lodash/filter'
import { selectProductModules } from '../product-modules/selectors'

const licenseSelector = (state) =>
  (state.licenses && state.licenses.licenses) || null
const licenseFilterSelector = (state) =>
  (state.licenses && state.licenses.filters) || null
const licenseCreateResponseSelector = (state) =>
  (state.licenses && state.licenses.create) || null
const licenseUpdateResponseSelector = (state) =>
  (state.licenses && state.licenses.update) || null
const brandLicensesSelector = (state) =>
  (state.licenses && state.licenses.licenses) || null

const PRODUCT_MODULE_ORDER = {
  'activate': 1,
  'perform': 2,
  'perform-pro': 3,
}

export const selectLicenses = createSelector(
  [licenseSelector, selectProductModules],
  (licenses, productModules) => {
    if (licenses && licenses.length && productModules.productModules) {
      const modules = productModules.productModules
      const updatedLicenses = licenses.map((license) => {
        const productModule = modules.find((item) => {
          return item.id === license.product_module_id
        })

        license.productModule = productModule.name

        return license
      })
      return { licenses: updatedLicenses }
    }
    return { licenses }
  },
)

export const selectLicensesPresent = createSelector(
  [licenseSelector],
  (licenses) => {
    return { licensesPresent: licenses && licenses.length > 0 }
  },
)

export const selectLicenseFilters = createSelector(
  [licenseFilterSelector],
  (filters) => {
    return { filters: filters || {} }
  },
)

export const selectCreateResponse = createSelector(
  [licenseCreateResponseSelector],
  (createResponse) => {
    return { createResponse }
  },
)

export const selectUpdateResponse = createSelector(
  [licenseUpdateResponseSelector],
  (updateResponse) => {
    return { updateResponse }
  },
)

export const selectBrandLicenses = createSelector(
  [brandLicensesSelector],
  (brandLicenses) => {
    return { brandLicenses }
  },
)

export const selectOrderedBrandLicenses = createSelector(
  [brandLicensesSelector],
  (brandLicenses) => {
    const orderedLicenses = orderBy(brandLicenses, (license) => {
      return (
        PRODUCT_MODULE_ORDER[
          license.product_module && license.product_module.key
        ] || 4
      )
    })

    const licenses = filter(orderedLicenses, (license) => {
      return license.state == 'active'
    })

    return { orderedLicenses: licenses }
  },
)
